export default {
  home: "首页",
  aboutUs: "关于我们",
  capabilities: "能力",
  esg: "可持续发展",
  careers: "职业",
  contact: "联系",
  ourJourney: "我们的历程",
  visionMission: "愿景与使命",
  leadershipTeam: "领导团队",
};

